export function applyResourceStringsTransformer(resourceStrings) {
    return (labelProps, value) => (value === labelProps.stringKey && resourceStrings[labelProps.stringKey]) || value;
}
//# sourceMappingURL=resourceStringsTransformer.js.map